import { useRouter, usePathname } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'
import { globalStore, useAppSelector } from '@app/model/store'
import { getState } from '@app/model/slice'

export const getCitySlug = (url) => {
  const storeGlobal = (globalStore.getState() as import('@app/model/store').RootState).global

  const delimitedUrl = url.replaceAll('/', ' ').trim().split(' ')
  const firstPath = delimitedUrl[0]
  const hasCity = storeGlobal?.cityList?.some((city) => city.slug === firstPath)
  return hasCity ? firstPath : false
}

export const isChangeCity = (url) => {
  const storeGlobal = (globalStore.getState() as import('@app/model/store').RootState).global

  const city = getCitySlug(url)
  if (!city) return false
  return storeGlobal?.currentCity ? city !== storeGlobal.currentCity.slug : false
}

export const isUrlToMainPage = (url) => {
  const delimitedUrl = url.replaceAll('/', ' ').trim().split(' ')
  const city = getCitySlug(url)
  const twoPath = delimitedUrl.includes('restaurants')
  const isTwoPaths = delimitedUrl.length === 2

  return city && twoPath && isTwoPaths
}

// Обработчик для определения типа перехода на новую страницу. (в текущей вкладке или в новой)
// + Возврат текущего статуса загрузки страницы (isLoadingPage)
// Откроется новая страница - город в ссылке отличается от текущего, указанного в store
// Откроется на текущей странице - город совпадает, либо в ссылке нет slug города, либо переход на главную страницу другого города (попап изменения города)
export const useRouterHandler = () => {
  const router = useRouter()
  const pathname = usePathname()
  const [isLoadingPage, setIsLoadingPage] = useState(false)
  const oldPathName = useRef(null)

  useEffect(() => {
    oldPathName.current = document.location.pathname

    const handleRouteChange = () => {
      const newPathName = document.location.pathname
      const url = window.location.href
      const isLinkWithAnotherCity = isChangeCity(url)

      if (isLinkWithAnotherCity) {
        const isLinkToCurrentProjectPage = isUrlToMainPage(url)
        if (!isLinkToCurrentProjectPage) {
          window.open(url, '_blank')
          return
        }
      }

      // Проверка для изменения основного url. Если меняется хеш, то загрузка ожидание загрузки страницы не включается
      if (newPathName != oldPathName.current) {
        oldPathName.current = newPathName
        setIsLoadingPage(true)
      }
    }

    window.addEventListener('popstate', handleRouteChange)
    return () => {
      window.removeEventListener('popstate', handleRouteChange)
    }
  }, [])

  useEffect(() => {
    setIsLoadingPage(false)
  }, [pathname])

  return [isLoadingPage]
}
